import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Trash2 } from "lucide-react";
import { api } from "../../lib/api";
import { CampaignsPanel } from "./CampaignsPanel";

const opts = { withCredentials: true };

export function NewsletterPanel() {
  const [view, setView] = useState("subscribers");
  return (
    <div>
      <div className="flex border-b border-[#D1CFC7] mb-8">
        {[["subscribers", "Inscrits"], ["campaigns", "Campagnes"]].map(([v, l]) => (
          <button key={v} onClick={() => setView(v)} data-testid={`newsletter-view-${v}`} className={`px-5 py-3 text-sm font-body border-b-2 -mb-px transition-colors ${view === v ? "border-[#1A1A1A] text-[#1A1A1A]" : "border-transparent text-[#757575]"}`}>{l}</button>
        ))}
      </div>
      {view === "subscribers" ? <SubscribersList /> : <CampaignsPanel />}
    </div>
  );
}

function SubscribersList() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/newsletter", opts).then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const exportCsv = async () => {
    try {
      const r = await api.get("/admin/newsletter/export", { ...opts, responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(r.data);
      a.download = `newsletter-cled-${new Date().toISOString().slice(0, 10)}.csv`;
      a.click();
      URL.revokeObjectURL(a.href);
    } catch {
      toast.error("L'export a échoué");
    }
  };
  const remove = async (s) => {
    if (!window.confirm(`Retirer ${s.email} de la liste ?`)) return;
    await api.delete(`/admin/newsletter/${s.id}`, opts);
    load();
  };

  return (
    <div data-testid="newsletter-panel">
      <div className="flex items-center justify-between mb-8 gap-4">
        <h2 className="font-serif text-4xl text-[#1A1A1A] font-light">Newsletter (<span data-testid="newsletter-count">{items.length}</span>)</h2>
        <button onClick={exportCsv} data-testid="newsletter-export-button" className="bg-[#2C402E] text-[#FAF9F6] px-4 py-2 text-sm font-body flex items-center gap-2 whitespace-nowrap"><Download size={14} /> Exporter CSV</button>
      </div>
      {items.length === 0 ? (
        <p className="font-body text-sm text-[#757575]" data-testid="newsletter-empty">Aucun inscrit pour le moment. Le formulaire apparaît à la fin de chaque histoire.</p>
      ) : (
        <div className="overflow-x-auto border border-[#D1CFC7]">
          <table className="w-full text-sm font-body">
            <thead className="bg-[#F4F1EA] text-left text-xs uppercase tracking-wider text-[#4A4A4A]">
              <tr><th className="p-3">E-mail</th><th className="p-3">Date</th><th className="p-3">Histoire</th><th className="p-3">Lieu</th><th className="p-3" /></tr>
            </thead>
            <tbody>
              {items.map((s) => (
                <tr key={s.id} data-testid={`subscriber-${s.id}`} className="border-t border-[#E8E4D9]">
                  <td className="p-3 text-[#1A1A1A]">{s.email}</td>
                  <td className="p-3 text-[#4A4A4A] whitespace-nowrap">{new Date(s.created_at).toLocaleDateString("fr-FR")}</td>
                  <td className="p-3 text-[#4A4A4A]">{s.extract_title || "—"}</td>
                  <td className="p-3 text-[#4A4A4A]">{s.lieu_name || "—"}</td>
                  <td className="p-3 text-right"><button onClick={() => remove(s)} data-testid={`delete-subscriber-${s.id}`} className="text-[#9E4735]"><Trash2 size={14} /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
